import * as React from "react";
import { GraphTestData } from "../Spirometry/SpirometryAnalysisScreen";

export interface GraphState {
    graphData: GraphTestData[];
}

const initialState = {
    graphData: null,
}

export enum GraphActionTypes {
    LoadInitialVisibility = "LoadInitialVisibility",
    ToggleTestGraphVisibility = "ToggleTestGraphVisibility",
}

export type GraphActions = LoadInitialVisibilityActionNextGen | ToggleTestGraphVisibilityAction;

export class LoadInitialVisibilityActionNextGen {
    type: GraphActionTypes.LoadInitialVisibility;
    graphData: GraphTestData[];

    static create(graphData: GraphTestData[]): LoadInitialVisibilityActionNextGen {
        return {
            type: GraphActionTypes.LoadInitialVisibility,
            graphData: graphData,
        };
    }
}

export class ToggleTestGraphVisibilityAction {
    type: GraphActionTypes.ToggleTestGraphVisibility;
    testId: string

    static create(testId: string): ToggleTestGraphVisibilityAction {
        return {
            type: GraphActionTypes.ToggleTestGraphVisibility,
            testId: testId,
        };
    }
}

export const useGraphs = (graphTestData: GraphTestData[]): [GraphState, React.Dispatch<GraphActions>] => {
    const reducer = (state: GraphState, action: GraphActions): GraphState => {
        switch (action.type) {
            case GraphActionTypes.LoadInitialVisibility:
                return {
                    ...state,
                    graphData: action.graphData,
                };
            case GraphActionTypes.ToggleTestGraphVisibility:
                return {
                    ...state,
                    graphData: state.graphData.map(t => {
                        if (t.TestId === action.testId) {
                            return {
                                ...t,
                                IsDisplayed: !t.IsDisplayed
                            }
                        } else {
                            return t;
                        }
                    })
                };
            default:
                throw new Error("Unexpected Graph action");
        }
    }

    const [state, dispatch] = React.useReducer(reducer, initialState);

    React.useEffect(() => {
        const hydrateAcceptability = () => {
            dispatch(LoadInitialVisibilityActionNextGen.create(graphTestData));
        };

        hydrateAcceptability();
    }, [graphTestData])

    return [state, dispatch];
}
